import { Form } from 'antd'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { isNil, filter, map, pathOr, join, length, equals } from 'ramda'
import { FieldError, NamePath } from 'rc-field-form/lib/interface'
const { compose } = require('ramda')

const keyMap = {}

interface Props {
  className?: string
  style?: React.CSSProperties
  isEdit?: boolean
  type?: 'simple' | 'details'
}

function renderFieldErrors(
  getFieldsError: (nameList?: NamePath[] | undefined) => FieldError[],
  type: string,
  errorMessage: string
) {
  const _errors = getFieldsError()

  let hasError = false

  const _checkErrors = (data: FieldError[]) => {
    data?.forEach(({ name, errors }: FieldError) => {
      if (!isNil(errors) && length(errors) > 0) {
        hasError = true
        return
      }
    })
  }

  _checkErrors(_errors)

  return hasError ? (
    equals(type, 'simple') ? (
      <div className="block mr-2">{errorMessage}</div>
    ) : (
      compose(
        map(({ name, errors }: FieldError) => {
          const key = join('.')(name)
          return (
            <div key={key} className="block mr-2">
              {pathOr(key, [key], keyMap)}：{join('、')(errors)}
            </div>
          )
        }),
        filter((x: FieldError) => x.errors.length > 0),
        pathOr([], [])
      )(_errors)
    )
  ) : null
}

export default function useFieldsError({
  isEdit,
  className = 'mt-12',
  type = 'simple',
  ...props
}: Props) {
  const { t } = useTranslation()

  return (
    isEdit && (
      <Form.Item shouldUpdate noStyle>
        {({ getFieldsError }) => (
          <div className={cx('pl-40 text-danger', className)} {...props}>
            {renderFieldErrors(
              getFieldsError,
              type,
              t('common:data failed, check each fields with * mark has value')
            )}
          </div>
        )}
      </Form.Item>
    )
  )
}
